const gamificationRoutes = {
  globalRanking: {
    path: '/ranking/global'
  },
  myGamificationProfile: {
    path: '/ranking/my-rank'
  },
  adminGamificationRewards: {
    path: '/admin/gamification/rewards'
  }
};

export default gamificationRoutes;
